import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider,TextField, Grid, Typography, Box,CircularProgress } from "@mui/material"

import {getTemplateStruct, setData} from './TemplateStruct'
import { updateTextValue, handleSubmit,updateValue,updateSelectedValue} from '../../core/js/FormUtils'
import {createAPI, updateAPI, getAPI, updateEditableAPI} from './TemplateAPI';
import {CoreContext} from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {validMobileNumberEntry, validNameEntry, validEmailEntry} from '../../core/js/FormValidation';

import {getPathVariable} from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch,useSelector } from 'react-redux';
import { updateTemplateObj,addTemplateObj, setShowEditForTemplate} from 'store/slice/ManufSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';
import { setMfproductAttachImageModal } from 'store/slice/ManufSlice';
import AttachImageActionModal from 'components/mfproduct/action/attachImage/AttachImageActionModal';
import {setSelectedImage, setSelectedAssetIdList} from 'store/slice/ImageGallerySlice';



export default function TemplateEditFormImpl(){
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getTemplateStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const {templateDashboard} = useSelector((state)=>state.manufslice);
    const [templateId, setTemplateId] = useState(templateDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo);
    const {selectedImage, selectedImagePath,selectedAssetIdList, selectedImageId} = useSelector((state) => state.imagegalleryslice);
    

    const {apiInProgress} = useSelector((state)=>state.headerslice)
    useEffect(()=>{
    },[apiInProgress])

    useEffect(() => {
        if (templateId!==-1) {
            if (dataLoaded) return;
            getAPI(templateId, loadForm);
        }
        else {
           // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            }
        })
        dispatch(setSelectedImage({ name: '',path: ''}));
        dispatch(setSelectedAssetIdList(''));
    },[]);
    useEffect(() => {
        setFormValues({
            ...formValues,
            ['assetname']: {
                ...formValues['assetname'],
                value: selectedImage
            },
            ['assetpath']: {
                ...formValues['assetpath'],
                value: selectedImagePath
            },
            ['assetid']: {
                ...formValues['assetid'],
                value: selectedImageId
            }
        });
    },[selectedImagePath]);

    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data)=>{
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value+" == "+getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value ) 
            return "yes"
        else 
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value ==="yes") 
            return true
        else 
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Remove newlines for the description field
        const sanitizedValue = value.replace(/[\r\n]+/g, '')
        updateTextValue(formValues, setFormValues, { target: { name, value: sanitizedValue } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;

        // Do not allow starting with '.'
        if (value.startsWith('.')) {
            return;
        }

        // Allow empty string so user can delete all characters
        if (value === '' || value === '.') {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
            return;
        }

        // Regex: Allow up to 9 digits before decimal, optional decimal, up to 2 digits after decimal (Indian Rupees format)
        const regex = /^\d{0,9}(\.\d{0,2})?$/;

        if (regex.test(value)) {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
        }
    }
    const handleNameChange = (e) =>{
        setShowError(false);
        
       if (validNameEntry(e))
        updateTextValue(formValues, setFormValues,e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);
        
       if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);
        
       if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }

    const createSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(addTemplateObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForTemplate(false));
    }
    const updateSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(updateTemplateObj(obj));
        setNotification('Record with id['+templateId+'] has been updated successfully !!!');
        dispatch(setShowEditForTemplate(false));
        
    }
    const failuerCallback = (errorMsg) => {
         dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id,formValues, updateSuccessCallback, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        updateAPI(id,formValues, updateSuccessCallback, failuerCallback);
    }
    const onSubmit=(e)=>{
        handleSubmit(e,templateId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);
        
        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr =date.getFullYear()+ "-" +  monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    const handleImageUpload = () => {
        dispatch(setMfproductAttachImageModal(true));
    }
    // Utility function to convert newlines to <br/>
    

    return (
        <form  noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError? <Alert severity="error">{errorMsg}</Alert>: ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{overflowY: "scroll", backgroundColor:'white',maxHeight:'75vh'}}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{templateId===-1?'Add':'Edit'} Marketing Template List </Typography>
                                <Divider/>
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="top">
                                    <Grid item lg={4} xs={12}>
                                      <Box sx={{  display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Box
                                          sx={{
                                            width: 250,
                                            height: 250,
                                            borderRadius: 2,
                                            overflow: 'hidden',
                                            background: '#f5f5f5',
                                            border: '1px solid #e0e0e0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mb: 1,
                                          }}
                                        >
                                          {formValues.assetpath.value ? (
                                            <img
                                              src={formValues.assetpath.value}
                                              alt="Template"
                                              style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                              }}
                                            />
                                          ) : (
                                            // Dummy blank image (SVG)
                                            <svg width="100%" height="100%" viewBox="0 0 120 120">
                                              <rect width="120" height="120" fill="#e0e0e0" />
                                              <text x="50%" y="50%" textAnchor="middle" dy=".3em" fill="#aaa" fontSize="16">No Image</text>
                                            </svg>
                                          )}
                                        </Box>
                                        <Button
                                          variant="contained"
                                          component="label"
                                          size="small"
                                          sx={{ mt: 1 }}
                                          onClick={handleImageUpload}
                                        >
                                          {formValues.assetpath.value ? 'Edit Image' : 'Upload Image'}
                                          
                                        </Button>
                                      </Box>
                                    </Grid>
                                    <Grid item lg={8} xs={12}>
                                        <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="top"> 
                                                                    
                                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helperText={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{width:'100%'}}
                                        />
                                    </Grid>
                                                    
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.title.placeholder}
                                            required={formValues.title.required}
                                            label={formValues.title.label}
                                            name={formValues.title.name}
                                            value={formValues.title.value}
                                            onChange={handleTextChange}
                                            error={formValues.title.error}
                                            helperText={formValues.title.error && formValues.title.errorMessage}
                                            sx={{width:'100%'}}
                                        />
                                    </Grid>
                                                    
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.assetid.placeholder}
                                            required={formValues.assetid.required}
                                            label={formValues.assetid.label}
                                            name={formValues.assetid.name}
                                            value={formValues.assetid.value}
                                            onChange={handleTextChange}
                                            error={formValues.assetid.error}
                                            helperText={formValues.assetid.error && formValues.assetid.errorMessage}
                                            sx={{width:'100%'}}
                                        />
                                    </Grid>
                                                    
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.assetname.placeholder}
                                            required={formValues.assetname.required}
                                            label={formValues.assetname.label}
                                            name={formValues.assetname.name}
                                            value={formValues.assetname.value}
                                            onChange={handleTextChange}
                                            error={formValues.assetname.error}
                                            helperText={formValues.assetname.error && formValues.assetname.errorMessage}
                                            sx={{width:'100%'}}
                                        />
                                    </Grid>
                                                    
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.assetpath.placeholder}
                                            required={formValues.assetpath.required}
                                            label={formValues.assetpath.label}
                                            name={formValues.assetpath.name}
                                            value={formValues.assetpath.value}
                                            onChange={handleTextChange}
                                            error={formValues.assetpath.error}
                                            helperText={formValues.assetpath.error && formValues.assetpath.errorMessage}
                                            sx={{width:'100%'}}
                                        />
                                    </Grid>
                                                    
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <TextField
                                            size="Normal"
                                            placeholder={formValues.campaigntext.placeholder}
                                            required={formValues.campaigntext.required}
                                            label={formValues.campaigntext.label}
                                            name={formValues.campaigntext.name}
                                            value={formValues.campaigntext.value}
                                            onChange={e => {
                                                setShowError(false);
                                                updateTextValue(formValues, setFormValues, e); // Preserve newlines
                                            }}
                                            error={formValues.campaigntext.error}
                                            helperText={formValues.campaigntext.error && formValues.campaigntext.errorMessage}
                                            sx={{ width: '100%' }}
                                            multiline
                                            rows={10}
                                        />
                                    </Grid>
                                
                                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                                <TextField size="Normal"
                                                    placeholder={formValues.businessid.placeholder}
                                                    required={formValues.businessid.required}
                                                    label={formValues.businessid.label}
                                                    name={formValues.businessid.name}
                                                    value={formValues.businessid.value}
                                                    onChange={handleTextChange}
                                                    error={formValues.businessid.error}
                                                    helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                                    sx={{ width: '100%',  }}
                                                />
                                            </Grid> 
                                        </Grid>
                                    </Grid>
                            </Grid>
                            :<></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider/>
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                {   apiInProgress?<CircularProgress/>:
                    <>
                        <Button variant="outlined" type="submit" >{templateId===-1?'Add':'Save'}</Button>&nbsp;&nbsp;&nbsp;
                        <Button variant="outlined" onClick={()=>{dispatch(setShowEditForTemplate(false));}}>Close</Button>
                    </>
                }
                </Grid>
            </Grid>
            <AttachImageActionModal/>
        </form>
    );
};